import { SignalCardAssetHeader } from "./SignalCardAssetHeader";
import type { SignalCardAssetProps } from "./types";
import { cn } from "utils";

export interface SignalCardShellProps extends SignalCardAssetProps {
  className?: string;
  children: React.ReactNode;
}

/** Figma 94103 系列信号卡统一容器。 */
export const SignalCardShell: React.FC<SignalCardShellProps> = ({
  className,
  children,
  ...asset
}) => {
  return (
    <div
      className={cn(
        "flex w-full flex-col gap-2 rounded-2 bg-background_white_overlay5 p-3",
        className,
      )}
    >
      <SignalCardAssetHeader {...asset} />
      {children}
    </div>
  );
};
